import { Field, Form } from 'react-final-form';
import InvestorImage from '../assets/images/invest.png';
import BorrowerImage from '../assets/images/personal.png';
import ServiceProviderImage from '../assets/images/compliant.png';
import { validateFormValues } from '../helpers';
import * as yup from 'yup';
import FormError from '../components/Common/FormError';
import { Link } from 'react-router-dom';
import useSignup from '../hooks/auth/useSignup';
import Notify from '../components/Common/Notify';
import LoadingIndicator from '../components/Common/LoadingIndicator';
import { ConfirmEmail } from '../components/ConfirmEmail/ConfirmEmail';
import { UserTypeId } from '../helpers/constants';
import useResendEmailConfirmation from '../hooks/auth/useResendEmailConfirmation';
import { useEffect } from 'react';

const SignupPage = () => {
  const validationSchema = yup.object({
    user_type_id: yup.string().required('Please select a user type'),
    firstname: yup.string().required('Firstname is required'),
    lastname: yup.string().required('Lastname is required'),
    email: yup.string().required('Email address is required').email('Please enter a valid email address'),
    password: yup.string().required('Please enter a password'),
    confirm_password: yup
      .string()
      .required('Please confirm your password')
      .oneOf([yup.ref('password'), null], 'Passwords must match'),
  });
  const validate = validateFormValues(validationSchema);
  const { onSubmitHandler, submitting, success, error, email } = useSignup();
  const { onClickHandler, successNoTimeout: successMail, submitting: submittingMail } = useResendEmailConfirmation();
  const signupAndEmailSuccess = success && successMail

  useEffect(() => {
    if (success && email) {
      console.log('SEND CONFIRMATION!!');
      onClickHandler(email);
    }
  }, [success, onClickHandler, email])

  return signupAndEmailSuccess ? (
    <ConfirmEmail email={email} />
  ) : (
    <>
      <Form
        onSubmit={onSubmitHandler}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <h2>Account Sign Up</h2>
            <h6 className='mb-7'>
              <span className='text-muted'>Already Have An Account?</span> <Link to='/'>Sign In</Link>
            </h6>
            {error && <Notify type='danger' message={error} />}
            <div className='fv-row'>
              <label className='form-label'>Sign Up As</label>
              <div className='row'>
                <div className='col-lg-4'>
                  <Field name='user_type_id' type='radio' value={UserTypeId.INVESTOR.toString()}>
                    {({ input, meta }) => (
                      <>
                        <input type='radio' {...input} name='user_type_id' className='btn-check' value={UserTypeId.INVESTOR.toString()} id='kt_register_user_type_investor' />
                        <FormError meta={meta} />
                      </>
                    )}
                  </Field>
                  <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor='kt_register_user_type_investor'>
                    <img src={InvestorImage} className='svg-icon-3x me-5' alt='investor' style={{ width: '35px' }} />

                    <span className='d-block fw-bold text-start'>
                      <span className='text-dark d-block fs-7 mb-2'>An Investor</span>
                      <span className='text-gray-400 fw-bold fs-8'>Give out loan</span>
                    </span>
                  </label>
                </div>

                <div className='col-lg-4'>
                  <Field name='user_type_id' type='radio' value={UserTypeId.BORROWER.toString()}>
                    {({ input, meta }) => (
                      <>
                        <input type='radio' {...input} name='user_type_id' className='btn-check' value={UserTypeId.BORROWER.toString()} id='kt_register_user_type_borrower' />
                        <FormError meta={meta} />
                      </>
                    )}
                  </Field>
                  <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor='kt_register_user_type_borrower'>
                    <img src={BorrowerImage} className='svg-icon-3x me-5' alt='borrower' style={{ width: '35px' }} />

                    <span className='d-block fw-bold text-start'>
                      <span className='text-dark d-block fs-7 mb-2'>A Borrower</span>
                      <span className='text-gray-400 fw-bold fs-8'>Request for loan</span>
                    </span>
                  </label>
                </div>

                <div className='col-lg-4'>
                  <Field name='user_type_id' type='radio' value={UserTypeId.SERVICE_PROVIDER.toString()}>
                    {({ input, meta }) => (
                      <>
                        <input type='radio' {...input} name='user_type_id' className='btn-check' value={UserTypeId.SERVICE_PROVIDER.toString()} id='kt_register_user_type_sp' />
                        <FormError meta={meta} />
                      </>
                    )}
                  </Field>
                  <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor='kt_register_user_type_sp'>
                    <img src={ServiceProviderImage} className='svg-icon-3x me-5' alt='provider' style={{ width: '35px' }} />

                    <span className='d-block fw-bold text-start'>
                      <span className='text-dark d-block fs-7 mb-2'>A Service Provider</span>
                      <span className='text-gray-400 fw-bold fs-8'>Profer service</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='mb-5 col-lg-6'>
                <Field name='firstname'>
                  {({ input, meta }) => (
                    <>
                      <label className='form-label'>Firstname</label>
                      <div className='mb-3'>
                        <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                        <FormError meta={meta} />
                      </div>
                    </>
                  )}
                </Field>
              </div>

              <div className='mb-5 col-lg-6'>
                <Field name='lastname'>
                  {({ input, meta }) => (
                    <>
                      <label className='form-label'>Lastname</label>
                      <div className='mb-3'>
                        <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                        <FormError meta={meta} />
                      </div>
                    </>
                  )}
                </Field>
              </div>
            </div>

            <div className='row'>
              <div className='mb-5 col-lg-6'>
                <Field name='email' type='email'>
                  {({ input, meta }) => (
                    <>
                      <label className='form-label'>Email</label>
                      <div className='mb-3'>
                        <input type='email' {...input} className='form-control form-control-lg form-control-solid' />
                        <FormError meta={meta} />
                      </div>
                    </>
                  )}
                </Field>
              </div>

              <div className='mb-5 col-lg-6'>
                <Field name='password'>
                  {({ input, meta }) => (
                    <>
                      <label className='form-label'>Password</label>
                      <div className='mb-3'>
                        <input type='password' {...input} className='form-control form-control-lg form-control-solid' />
                        <FormError meta={meta} />
                      </div>
                    </>
                  )}
                </Field>
              </div>
            </div>

            <div className='row'>
              <div className='mb-5 col-md-6'>
                <Field name='confirm_password'>
                  {({ input, meta }) => (
                    <>
                      <label className='form-label'>Confirm Password</label>
                      <div className='mb-3'>
                        <input type='password' {...input} className='form-control form-control-lg form-control-solid' />
                        <FormError meta={meta} />
                      </div>
                    </>
                  )}
                </Field>
              </div>

              <div className='mb-5 col-md-6'>
                <button type='submit' disabled={submitting || submittingMail} className='btn btn-primary btn-block mt-8 w-100'>
                  {submitting || submittingMail ? <LoadingIndicator /> : 'Create My Account'}
                </button>
              </div>
              <div className='text-center fs-8 text-muted'>By clicking the “Create My Account” button, you agree to MortFi’s terms and privacy policy.</div>
            </div>
          </form>
        )}
      />
    </>
  );
};

export default SignupPage;
